import React from 'react'
import { Modal } from './Modal'
import { ModalHeader } from './ModalHeader'
import { ModalBody } from './ModalBody'
import { ModalFooter } from './ModalFooter'

const StockSummaryConfirmationModal = ({
  confirmationAction,
  closeConfirmationModal,
  actionLoading,
  cancellationReason,
  setCancellationReason,
  handleConfirmAction,
}:{
  confirmationAction: {
    requestId: string;
    status: 'PROCESS' | 'COMPLETE' | 'DISPATCH' | 'CANCELLED';
    sourceType: string;
  } | null;
  closeConfirmationModal: () => void;
  actionLoading: boolean;
  cancellationReason: string;
  setCancellationReason: (reason: string) => void;
  handleConfirmAction: () => void;
}) => {
  return (
    <Modal
            isOpen={Boolean(confirmationAction)}
            onClose={closeConfirmationModal}
            size="md"
            isLoading={actionLoading}
          >
            <ModalHeader
              title={
                confirmationAction?.status === 'PROCESS'
                  ? 'Process Request'
                  : confirmationAction?.status === 'COMPLETE'
                    ? 'Complete Request'
                    : confirmationAction?.status === 'DISPATCH'
                      ? 'Dispatch Request'
                      : 'Cancel Request'
              }
              onClose={closeConfirmationModal}
            />
            <ModalBody>
              <div className="flex flex-col gap-3">
                <div className="text-sm text-gray-600">
                  {confirmationAction?.status === 'PROCESS'
                    ? 'Are you sure you want to mark this request as processing?'
                    : confirmationAction?.status === 'COMPLETE'
                      ? 'Are you sure you want to complete this request?'
                      : confirmationAction?.status === 'DISPATCH'
                        ? 'Are you sure you want to dispatch this request?'
                        : 'Are you sure you want to cancel this request?'}
                </div>
    
                {confirmationAction?.status === 'CANCELLED' && (
                  <div className="flex flex-col gap-1">
                    <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-500">
                      Cancellation Reason
                    </label>
                    <textarea
                      rows={3}
                      value={cancellationReason}
                      onChange={(event) => setCancellationReason(event.target.value)}
                      placeholder="Enter reason for cancellation..."
                      disabled={actionLoading}
                      className="w-full resize-none rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm text-slate-700 shadow-sm focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-100 disabled:opacity-60"
                    />
                  </div>
                )}
              </div>
            </ModalBody>
            <ModalFooter
              onCancel={closeConfirmationModal}
              onPrimary={handleConfirmAction}
              cancelLabel="Cancel"
              primaryLabel="Okay"
              primaryDisabled={actionLoading}
              loading={actionLoading}
              loadingLabel="Processing..."
            />
          </Modal>
  )
}

export default StockSummaryConfirmationModal
